.checkboxWrapper {
  padding-top: var(--via-space-100);
  padding-bottom: var(--via-space-100);
}

.checkboxWrapperNested {
  padding-left: 1em;
}

.checkboxWrapperAll {
  border-bottom: 1px solid var(--via-color-neutral-200);
}

.checkboxContainer {
  min-width: 150px; /* need to set this as side effect of getPopupContainer */
  font-weight: normal; /* need to set this as side effect of getPopupContainer */
}
